/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Interval_HelpInputs */

const en_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often your work will be automatically saved`)
};

const fr_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d'enregistrement automatique de votre travail`)
};

const de_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft Ihre Arbeit automatisch gespeichert wird`)
};

const it_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con quale frequenza il tuo lavoro verrà salvato automaticamente`)
};

const ru_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как часто ваша работа будет автоматически сохраняться`)
};

const es_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con qué frecuencia se guardará automáticamente su trabajo`)
};

const zh_cn2_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的工作将多久自动保存一次？`)
};

const ja_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業を自動的に保存する頻度`)
};

const hi_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका काम कितनी बार अपने आप सेव होगा`)
};

const pt_pt2_options_backup_save_interval_help = /** @type {(inputs: Options_Backup_Save_Interval_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência seu trabalho será salvo automaticamente?`)
};

/**
* | output |
* | --- |
* | "How often your work will be automatically saved" |
*
* @param {Options_Backup_Save_Interval_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_interval_help = /** @type {((inputs?: Options_Backup_Save_Interval_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Interval_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_save_interval_help(inputs)
	if (locale === "de") return de_options_backup_save_interval_help(inputs)
	if (locale === "it") return it_options_backup_save_interval_help(inputs)
	if (locale === "ru") return ru_options_backup_save_interval_help(inputs)
	if (locale === "es") return es_options_backup_save_interval_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_save_interval_help(inputs)
	if (locale === "ja") return ja_options_backup_save_interval_help(inputs)
	if (locale === "hi") return hi_options_backup_save_interval_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_save_interval_help(inputs)
	return en_options_backup_save_interval_help(inputs)
});